/* eslint-disable max-len */
import React from 'react';
import { Dropdown } from '@mhub/web-components';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import i18n from '../i18n';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

const languageOptions = [
  {
    key: 'en', value: 'en', text: 'English',
  },
  {
    key: 'vi', value: 'vi', text: 'Vietnamese',
  },
  // {
  //   key: 'id', value: 'id', text: 'Indonesian',
  // },
];

const LanguageSelector = ({ t }) => {
  const handleChange = (e, { value }) => {
    i18n.changeLanguage(value);
  };

  return (
    <Dropdown
      selection
      options={languageOptions.map(option => ({ ...option, text: t(option.text, { ns: TRANSLATION_FILES.constants }) }))}
      value={i18n.resolvedLanguage || i18n.language}
      onChange={handleChange}
    />
  );
};

LanguageSelector.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(namespaces)(LanguageSelector);
